import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { IVideoLessionFile, IVideoLessionProgramFileProps } from "./VideoLessionFileModels"
import { LoadingButton } from "@mui/lab"
import { useState } from "react"
import moment from "moment"
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import VideoLessionFileService from "./videoLessionFileService"
import ProgramFileUploadComponent from "../programFileUpload/programFileUpload"
import { FileTypeIcon } from "../../common/components/FileTypeIcon"
import { getFileNameWithOutExt } from "../../common/utilities/utils";
export const VideoLessionProgramFiles = (props: IVideoLessionProgramFileProps) => {
    const { fileUploadIsInProgress, handleFileUpload, handleDelete, programFiles, tableSxProps, videoLessionProgramProps, subjectId } = props;
    const handleDownloadClick = (programFile: IVideoLessionFile) => {
        const fileDownloadUrl = VideoLessionFileService.getFileDownloadUrl(programFile.fileId);
        window.open(fileDownloadUrl, '_blank');
    }

    return (
        <>
            {videoLessionProgramProps.isAddFilesVisible && <ProgramFileUploadComponent handleFileChange={(e) => {
                handleFileUpload(subjectId, e)
            }} fileUploadIsInProgress={fileUploadIsInProgress}></ProgramFileUploadComponent>}
            <TableContainer sx={{
                width: "100%",
                maxHeight: "70vh",
                minHeight: "70vh",
                overflowY: "auto",
                ...tableSxProps
            }}>
                <Table sx={{ minWidth: 650 }} aria-label="files table" stickyHeader className="oe-files-bg">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em', bgcolor: 'grey.50' }}>File Name</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em', bgcolor: 'grey.50' }}>Uploaded Date</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em', bgcolor: 'grey.50' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {programFiles.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={3} align="center">
                                    <Typography color="text.secondary" sx={{ py: 4 }}>No files uploaded yet.</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {programFiles.map((file) => (
                            <TableRow key={file.fileId} sx={{ '&:hover': { bgcolor: 'action.hover' } }}>
                                <TableCell>
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <FileTypeIcon fileName={file.fileName} />
                                        <Typography sx={{ fontSize: '0.875rem' }}>{getFileNameWithOutExt(file.fileName)}</Typography>
                                    </Stack>
                                </TableCell>
                                <TableCell sx={{ color: 'text.secondary', fontSize: '0.8rem' }}>{moment(file.createdDate).format('DD-MMM-YYYY HH:mm')}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Stack direction="row" spacing={1}>
                                        <LoadingButton
                                            variant="contained"
                                            size="small"
                                            startIcon={<CloudDownloadIcon />}
                                            onClick={() => handleDownloadClick(file)}
                                        >
                                            Download
                                        </LoadingButton>
                                        {videoLessionProgramProps.isDeleteFilesVisible && (
                                            <LoadingButton
                                                loading={file.isDeleteInProgress}
                                                variant="outlined"
                                                color="error"
                                                size="small"
                                                startIcon={<DeleteIcon />}
                                                loadingPosition="start"
                                                onClick={() => {
                                                    if (window.confirm(`Delete "${getFileNameWithOutExt(file.fileName)}"?`)) {
                                                        handleDelete(file);
                                                    }
                                                }}
                                            >
                                                Delete
                                            </LoadingButton>
                                        )}
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </>
    )
}